import React, { Component } from 'react'
import SignIn from './SignIn/index.jsx'
import Registration from './Registration/index.jsx'
import Recover from './Recover/index.jsx'
import ComponentsRoute from './Router/index.jsx'
import { translation } from './Translate/translation'
import Intercom from '.././intercom.js'
import Menu from './Menu/index.jsx'
import Footer from './Footer/index.jsx'
import CommonFetch from '../requests/commonFetch'
import Payment from './Payment/index.jsx'
import Subscribe from './Subscribe/index.jsx'

import { Route, Switch, Redirect } from 'react-router-dom'

export default class App extends Component {
    constructor(props) {
        super(props)

        this.state = {
            signIn: false,
            captcha_key: '',
            success: false,
            error: '',
            language: 'en',
            tfa_code_request_required: false,
            tfa_type: '',
            sessionMessage: '',
            overdueSession: false,
        }

        if (!localStorage['language'] && !localStorage['translation']) {
            localStorage.setItem('language', this.state.language)
            localStorage.setItem('translation', JSON.stringify(translation))
        }

        this.translation = JSON.parse(localStorage.translation)[
            localStorage.language
        ]
    }

    componentWillMount() {
        this.getStatus()
        Intercom()
    }

    componentDidUpdate(prevProps, prevState) {
        if (!(this.state.signIn === prevState.signIn)) {
            Intercom()
        }
    }

    getStatus = () => {
        CommonFetch({
            path: 'ui/get_status',
            method: 'GET',
        }).then(data => {
            let duplicateState = Object.assign({}, this.state)
            if (data.success) {
                localStorage.setItem('language', data.language.toLowerCase())
                localStorage.setItem('translation', JSON.stringify(translation))
                localStorage.setItem('csrf_token', data.csrf_token)

                for (let item in data) {
                    if (this.state[item] !== data[item]) {
                        if (item === 'logged_in') {
                            duplicateState['signIn'] = data[item]
                        } else if (item === '2fa_code_request_required') {
                            duplicateState['tfa_code_request_required'] =
                                data[item]
                        } else if (item === '2fa_type') {
                            if (data[item] === 'email') {
                                duplicateState['tfa_type'] = 'Email'
                            } else if (data[item] === 'sms') {
                                duplicateState['tfa_type'] = 'SMS'
                            } else if (data[item] === 'ga') {
                                duplicateState['tfa_type'] =
                                    'Google authenticator'
                            }
                        } else {
                            duplicateState[item] = data[item]
                        }
                    }
                }
            }

            this.setState({ ...duplicateState })
        })
    }

    render() {
        let {pathname} = this.props.location
        let payment = pathname.slice(1) === 'payment'
        let subscribe = pathname.slice(1) === 'subscribe'
        let unsubscribe = pathname.slice(1) === 'unsubscribe'

        return (
            <React.Fragment>
                {this.state.success && payment ? (
                    <Route
                        path="/payment"
                        render={props => (
                            <Payment
                                signIn={this.state.signIn}
                                switchSignIn={this.switchSignIn}
                                captchaKey={this.state.captcha_key}
                                {...props}
                            />
                        )}
                    />
                ): null}
                {this.state.success && subscribe ? (
                    <Route
                        path="/subscribe"
                        render={props => (
                            <Subscribe
                                signIn={this.state.signIn}
                                switchSignIn={this.switchSignIn}
                                captchaKey={this.state.captcha_key}
                                pathname={pathname.slice(1)}
                                {...props}
                            />
                        )}
                    />
                ): null}
                {this.state.success && unsubscribe ? (
                    <Route
                        path="/unsubscribe"
                        render={props => (
                            <Subscribe
                                signIn={this.state.signIn}
                                switchSignIn={this.switchSignIn}
                                captchaKey={this.state.captcha_key}
                                pathname={pathname.slice(1)}
                                {...props}
                            />
                        )}
                    />
                ): null}
                {this.state.success && !payment && !subscribe && !unsubscribe? (
                    <React.Fragment>
                        <input id="toggle" type="checkbox" />
                        <Menu
                            signIn={this.state.signIn}
                            switchSignIn={this.switchSignIn}
                            language={localStorage.language}
                            getStatus={this.getStatus}
                        />
                    </React.Fragment>
                ): null}
                {this.state.success && !payment && !subscribe && !unsubscribe? (
                    <div className="content">
                        <div className="container">
                            <Switch>
                                <Route
                                    exact
                                    path={'/'}
                                    render={() =>
                                        this.state.signIn ? (
                                            <Redirect to="/investor" />
                                        ) : (
                                            <Redirect to="/login" />
                                        )
                                    }
                                />
                                <Route
                                    path="/login"
                                    render={props => (
                                        <SignIn
                                            switchSignIn={this.switchSignIn}
                                            signIn={this.state.signIn}
                                            captchaKey={this.state.captcha_key}
                                            {...props}
                                        />
                                    )}
                                />
                                <Route
                                    path="/registration"
                                    render={props => (
                                        <Registration
                                            signIn={this.state.signIn}
                                            switchSignIn={this.switchSignIn}
                                            captchaKey={this.state.captcha_key}
                                            {...props}
                                        />
                                    )}
                                />
                                <Route
                                    path="/recover"
                                    render={props => (
                                        <Recover
                                            signIn={this.state.signIn}
                                            switchSignIn={this.switchSignIn}
                                            captchaKey={this.state.captcha_key}
                                            {...props}
                                        />
                                    )}
                                />
                                <SecretRoute
                                    path="/investor"
                                    component={ComponentsRoute}
                                    switchSignIn={this.switchSignIn}
                                    signIn={this.state.signIn}
                                    exitOverdueSession={this.exitOverdueSession}
                                    tfaCodeRequestRequired={
                                        this.state.tfa_code_request_required
                                    }
                                    tfaType={this.state.tfa_type}
                                    getStatus={this.getStatus}
                                />
                                <Redirect to="/investor" />
                            </Switch>
                        </div>
                    </div>
                ) : null}
                {this.messageCloseSessionView()}
            </React.Fragment>
        )
    }

    exitOverdueSession = () => {
        if (this.state.signIn)
            this.setState({
                overdueSession: true,
                sessionMessage: 'session is out of date',
                signIn: false,
            })
    }

    switchSignIn = () => {
        this.setState({
            signIn: !this.state.signIn,
        })
    }

    messageCloseSessionView = () => {
        return (
            <div
                className={`session ${
                    this.state.overdueSession ? 'active' : ''
                }`}
                onClick={() => this.setState({ overdueSession: false })}
            >
                <div className="session_error-message">
                    <p>{this.translation[this.state.sessionMessage]}</p>
                </div>
            </div>
        )
    }
}

const SecretRoute = ({
    component: Component,
    signIn,
    exitOverdueSession,
    tfaCodeRequestRequired,
    tfaType,
    getStatus,
    ...rest
}) => (
    <Route
        {...rest}
        render={props =>
            signIn ? (
                <div>
                    <Component
                        tfaCodeRequestRequired={tfaCodeRequestRequired}
                        tfaType={tfaType}
                        exitOverdueSession={exitOverdueSession}
                        getStatus={getStatus}
                        {...props}
                    />
                    <Footer />
                </div>
            ) : (
                <Redirect
                    to={{
                        pathname: '/login',
                        state: { from: props.location },
                    }}
                />
            )
        }
    />
)
